import debounce from 'lodash.debounce';

import isObject from '#shared/util/isObject.js';

import defaultGlobal from '#themes/default/default/components/global/global.js';

import cBreadcrumb from '#themes/default/web/components/breadcrumb/breadcrumb.js';
import cError from '#themes/default/web/components/error/error.js';
import cFooter from '#themes/default/web/components/footer/footer.js';
import cHeader from '#themes/default/ipm/components/header/header.js';
import cModal from '#themes/default/web/components/modal/modal.js';
import cNotificationBar from '#themes/default/web/components/notificationBar/notificationBar.js';
import cPageLayout from '#themes/default/web/layouts/pageLayout/pageLayout.js';
import cPaymentMethods from '#themes/default/web/components/paymentMethods/paymentMethods.js';
import cPaymentSelection from '#themes/default/web/components/paymentSelection/paymentSelection.js';
import cSidebar from '#themes/default/web/components/sidebar/sidebar.js';
import cSvgStorage from '#themes/default/web/components/svgStorage/svgStorage.js';
import cTopHeader from '#themes/default/web/components/topHeader/topHeader.js';

import template from './html/global.html' with { type: 'html' };

export default {
	middleware: defaultGlobal.middleware,
	components: {
		cBreadcrumb,
		cError,
		cFooter,
		cHeader,
		cModal,
		cNotificationBar,
		cPageLayout,
		cPaymentMethods,
		cPaymentSelection,
		cSidebar,
		cSvgStorage,
		cTopHeader
	},
	extends: defaultGlobal,
	data() {
		return {
			isSmallDevice: false,
			debouncedResize: null
		};
	},
	mounted() {
		this.debouncedResize = debounce(this.isMobileDevice, 300);
		window.addEventListener('resize', this.debouncedResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.debouncedResize);
	},
	computed: {
		isInvoicePage() {
			return isObject(this.page) && this.page.number === 5;
		}
	},
	methods: {
		isMobileDevice() {
			if (typeof window === 'undefined' || typeof navigator === 'undefined') {
				this.isSmallDevice = false;
			} else {
				// Check if the screen size points to be a small device / a mobile phone or the user agent says so
				this.isSmallDevice = window.innerWidth < 1023 || navigator.userAgent.indexOf('Mobi') > -1;
			}
		}
	},
	template
};
